import { Z } from "./z";

window.z = window.z || {} as Z;

// tslint:disable:no-var-requires

require("../../lib/core");
require("../../lib/jquery.signalR-2.2.0.min");

require("./array.extensions");
require("./dateTime.extensions");
require("./jquery.extensions");
require("./string.extensions");
require("../components/mask.extensions");
require("../components/zValidator");
require("../components/binders");
require("../dataComponents/gridUtil.extensions");
require("../../app/core/util/jquery.extensions");
